export const PAGE_EMBEDDINGS_DB_TASK_ID = 'flashcards.pageEmbeddings'
